export const socketGamePath = 'game';
export const gameName = 'Extra-King-100';
